import { getApplicationType } from './application-type';

export { getApplicationType };
